<template>
  <el-dialog
    append-to-body
    title="Talep Detay"
    :visible.sync="Modal"
    width="70%">
    <a @click="$emit('Kapat',true)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-row :gutter="24">
      <el-col :span="5">
        <table class="table-nohover table tablebordered table-xs ">
          <thead>
          <tr>
            <th>KİŞİ BİLGİ</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <small class="d-block">AD SOYAD</small>
              {{ Data.AdSoyad }}
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">TELEFON</small>
              {{ Data.Telefon }}
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">ADRES</small>
              {{ Data.Adres }}
            </td>
          </tr>
          <tr v-if="Detay.AboneNo">
            <td>
              <small class="d-block">Yapıfen Abone No</small>
              {{ Detay.AboneNo }}
            </td>
          </tr>
          </tbody>
        </table>
        <Notlar :data="Notlars"></Notlar>
      </el-col>
      <el-col :span="5">
        <table class="table-nohover table tablebordered table-xs ">
          <thead>
          <tr>
            <th>SİPARİŞ BİLGİ</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <small class="d-block">DURUM <a style="font-size: 12px" href="#" @click="DurumOlay" class="float-right">
                <i v-if="!DurumGuncelle" class="el-icon-refresh-right"></i>
                <i v-if="DurumGuncelle" class="el-icon-close" style="color: red"></i>
              </a> </small>
              <span v-if="!DurumGuncelle"> {{ Data.DurumText }}</span>
              <el-select v-if="DurumGuncelle" @change="DurumDegistir" size="mini" v-model="Durum" filterable>
                <el-option
                  v-for="item in Durumlar"
                  :key="item.id"
                  :label="item.Adi"
                  :value="item.id">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">HİZMET
                <a style="font-size: 12px" href="#" @click="HizmetOlay" class="float-right">
                  <i v-if="!HizmetGuncelle" class="el-icon-refresh-right"></i>
                  <i v-if="HizmetGuncelle" class="el-icon-close" style="color: red"></i>
                </a>
              </small>
              <span v-if="!HizmetGuncelle">{{ Data.Hizmet }}</span>
              <el-select v-if="HizmetGuncelle" @change="HizmetDegistir" size="mini" v-model="Hizmet_id" filterable>
                <el-option-group
                  v-for="group in Hizmetler"
                  :key="group.Tanim"
                  :label="group.Tanim">
                  <el-option
                    v-for="item in group.Alt"
                    :key="item.id"
                    :label="item.Tanim"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">KEŞİF RANDEVU ZAMANI</small>
              <el-date-picker
                size="mini"
                clearable
                v-model="Data.Randevu"
                type="datetime"
                @change="TarihGuncelle"
                placeholder="Randevu Zamanı">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">BAŞLANGIÇ TARİHİ</small>
              <el-date-picker
                size="mini"
                clearable
                v-model="Data.bTarih"
                type="date"
                @change="TarihGuncelle"
                placeholder="Başlama Tarihi">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">TESLİM TARİHİ</small>
              <el-date-picker
                size="mini"
                clearable
                v-model="Data.tTarih"
                type="date"
                @change="TarihGuncelle"
                placeholder="Teslim Tarihi">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">AÇIKLAMA</small>
              {{ Data.Aciklama }}
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">KAMPANYA <a style="font-size: 12px" href="#" @click="KampanyaOlay"
                                                 class="float-right">
                <i v-if="!KampanyaGuncelle" class="el-icon-refresh-right"></i>
                <i v-if="KampanyaGuncelle" class="el-icon-close" style="color: red"></i>
              </a> </small>
              <span v-if="!KampanyaGuncelle && Kampanya"> {{ Kampanya.Adi }}</span>
              <el-select v-if="KampanyaGuncelle" @change="KampanyaDegistir" size="mini" v-model="Kampanya_id"
                         filterable>
                <el-option
                  v-for="item in Kampanyalar"
                  :key="item.id"
                  :label="item.Adi"
                  :value="item.id">
                </el-option>
              </el-select>
            </td>
          </tr>

          </tbody>
        </table>
      </el-col>
      <el-col :span="9">
        <table class="table-nohover table tablebordered table-xs ">
          <thead>
          <tr>
            <th colspan="2">FİYATLANDIRMA
              <a @click="YeniInput" class="pull-right">KALEM EKLE</a>
            </th>
          </tr>
          <tr>
            <th>TÜR</th>
            <th width="150" class="text-right">TUTAR</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="f in Fiyatlar">
            <td>
              <el-input @change="TutarIslem" v-model="f.Aciklama"></el-input>
            </td>
            <td class="text-right">
              <el-input @change="TutarIslem" v-model="f.Odenecek"></el-input>
            </td>
          </tr>
          </tbody>
          <tfoot v-if="Detay">
          <tr>
            <th class="text-right">ALT TOPLAM</th>
            <th class="text-right">{{ Detay.Hizmet.Ucret }}<sup>TL</sup></th>
          </tr>
          <tr>
            <th class="text-right">İNDİRİM</th>
            <th class="text-right">
              <el-input @change="TutarIslem" v-model="Detay.Hizmet.Indirim"></el-input>
            </th>
          </tr>
          <tr>
            <th class="text-right">ÖDENECEK</th>
            <th class="text-right">{{ Detay.Hizmet.Odenecek }}<sup>TL</sup></th>
          </tr>
          </tfoot>
        </table>
        <el-button v-if="FiyatDegisiklik" @click="FiyatGuncelle" class="btn-block" size="small" type="info">
          FİYATLANDIRMAYI KAYDET
        </el-button>
      </el-col>
      <el-col :span="5">
        <div class="scrollkaydir" style="height: 300px">
          <table class="table-nohover table tablebordered table-xs ">
            <thead>
            <tr>
              <th>
                YORUMLAR
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="y in Yorumlar">
              <td>
                <small class="d-block">
                  Açıklama
                </small>
                {{ y.Aciklama }}
                <small class="d-block">
                  Tarih - Ekleyen
                </small>
                {{ y.tarih }} - {{ y.Ekleyen }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <el-input type="textarea" v-model="YeniYorum" placeholder="Yorum açıklaması"></el-input>
        <el-button type="success" size="mini" class="btn-block" @click="YorumEkle">Yorum Ekle</el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import Notlar from "../../../components/Pack/Genel/Notlar";
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor, Notlar},
  props: ['Data'],
  data() {
    return {
      Detay: null,
      YeniYorum: null,
      Fiyatlar: [],
      Kampanya: null,
      Yorumlar: null,
      Durum: this.Data.Durum,
      Hizmet_id: this.Data.Hizmet_id,
      Kampanya_id: null,
      Modal: true,
      FiyatDegisiklik: false,
      lo: false,
      KampanyaGuncelle: false,
      DurumGuncelle: false,
      HizmetGuncelle: false,
      Hizmetler: null,
      Durumlar: [
        {id: '1', Adi: 'Keşif Bekliyor'},
        {id: '2', Adi: 'Ödeme Bekliyor'},
        {id: '3', Adi: 'İşlem Yapılıyor'},
        {id: '4', Adi: 'Teslim Edildi'},
        {id: '5', Adi: 'İptal Edildi'},
      ],
      Notlars: {
        Modul: 's_Talep',
        Modul_id: this.Data.id
      }
    }
  },
  methods: {
    SayfaYukle() {
      this.DetayGetir();
      this.lo = true;
      this.$store.dispatch("Post", {path: '_ju/spesiyal/hizmetler'})
        .then(response => {
          this.lo = false;
          this.Hizmetler = response.Hizmetler
          this.Kampanyalar = response.Kampanyalar
        });
    },
    TutarIslem() {
      this.FiyatDegisiklik = true
      this.Detay.Hizmet.Ucret = 0;

      this.Fiyatlar.forEach(row => {
        this.Detay.Hizmet.Ucret += Number(row.Odenecek)
      })
      this.Detay.Hizmet.Odenecek = this.Detay.Hizmet.Ucret - Number(this.Detay.Hizmet.Indirim);
    },
    YeniInput() {
      this.Fiyatlar.push({
        Aciklama: 'Yeni Kalem',
        Odenecek: 0
      })
    },
    FiyatGuncelle() {
      this.lo = true;
      this.$store.dispatch("Post", {
        Fiyatlar: this.Fiyatlar, Hesap: this.Detay.Hizmet, path: '_ju/spesiyal/fiyat/' + this.Data.id
      }).then(response => {
        this.lo = false;
        this.$message.success(response.Mesaj);
      })
    },
    DetayGetir() {
      this.lo = true;
      this.$store.dispatch("Get", {path: '_ju/spesiyal/detay/' + this.Data.id})
        .then(response => {
          this.lo = false;
          this.Detay = response.Detay
          if (response.Fiyatlar) this.Fiyatlar = response.Fiyatlar
          this.Kampanya = response.Kampanya
          this.Yorumlar = response.Yorumlar
          if (response.Kampanya) this.Kampanya_id = response.Kampanya.id

        })
    },
    DurumOlay() {
      if (this.DurumGuncelle) this.DurumGuncelle = false; else this.DurumGuncelle = true
    },
    KampanyaOlay() {
      if (this.KampanyaGuncelle) this.KampanyaGuncelle = false; else this.KampanyaGuncelle = true
    },
    HizmetOlay() {

      if (this.HizmetGuncelle) this.HizmetGuncelle = false; else this.HizmetGuncelle = true
    },
    TarihGuncelle() {
      this.$store.dispatch("Post", {
        Randevu: this.Data.Randevu,
        bTarih: this.Data.bTarih,
        tTarih: this.Data.tTarih,
        id: this.Data.id,
        path: '_ju/spesiyal/tarih'
      })
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    YorumEkle() {
      this.lo = true;
      this.$store.dispatch("Post", {YeniYorum: this.YeniYorum, id: this.Data.id, path: '_ju/spesiyal/yorum'})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.Yorumlar = response.Yorumlar
            this.YeniYorum = ''
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    HizmetDegistir() {
      this.lo = true;
      this.$store.dispatch("Post", {Hizmet_id: this.Hizmet_id, id: this.Data.id, path: '_ju/spesiyal/hizmet'})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.HizmetGuncelle = false
            this.Data.Hizmet = response.Hizmet
            this.Data.Hizmet_id = this.Hizmet_id
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    DurumDegistir() {
      this.lo = true;
      this.$store.dispatch("Post", {Durum: this.Durum, id: this.Data.id, path: '_ju/spesiyal/durum'})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.DurumGuncelle = false
            this.Data.DurumText = response.Durums
            this.Data.Durum = this.Durum
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    KampanyaDegistir() {
      this.lo = true;
      this.$store.dispatch("Post", {Kampanya_id: this.Kampanya_id, id: this.Data.id, path: '_ju/spesiyal/kampanya'})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.KampanyaGuncelle = false
            this.Kampanya = response.Kampanya
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    }
  },
  created() {
    this.SayfaYukle();
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/JetUsta/Comp/juTalepDetay.vue